import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  checkboxLabel: {
    display: 'inline',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '14px',
    color: '2C2D3E',
    paddingLeft: '5px',
  },
  validationError: {
    maxHeight: '120px',
    overflow: 'auto',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: '#BC0000',
    textAlign: 'left',
    paddingLeft: '40px',
  },
  h6: {
    margin: '0px',
    fontFamily: 'Roboto',
    fontweight: 500,
    fontSize: '1.25rem !important',
  }
}));
